<template>
  <section id="blogs" class="relative mb-80 sm:mb-0">
    <div class="h-screen">
      <div class="h-full flex flex-col justify-center relative">
        <div class="text-center mb-8 -mt-36 exp">
          <p>***</p>
          <p
            data-aos="fade-right"
            data-aos-duration="1000"
            data-aos-easing="ease-in-sine"
            class="font-bold"
          >
            Blogs
          </p>
          <!-- cate wrapper -->
          <div class="flex justify-center items-center mt-5 relative z-30 md:z-50">
            <div
              style="white-space: nowrap"
              :class="[$root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg']"
              class="
                w-64
                md:w-96
                flex
                items-center
                justify-center
                py-2
                px-3
                md:py-3 md:px-4
                rounded-full
                space-x-6
                md:space-x-7
              "
            >
              <button @click="left" class="text-xl flex">
                <i class="fas fa-arrow-left"></i>
              </button>
              <div
                class="flex items-center overflow-x-auto scroller_cate"
                id="content"
              >
                <button
                  @click="cate = 'all'"
                  :class="[cate == 'all' ? 'active_blogs_cate' : '']"
                  class="mx-4 text-sm"
                >
                  All
                  <span
                    class="
                      text-xs
                      bg-green-400
                      w-5
                      h-4
                      inline-block
                      rounded-full
                      text-white
                    "
                    >6</span
                  >
                </button>
                <button
                  @click="cate = 'laravel'"
                  :class="[cate == 'laravel' ? 'active_blogs_cate' : '']"
                  class="mx-4"
                >
                  Laravel
                  <span
                    class="
                      text-xs
                      bg-red-600
                      text-white
                      w-5
                      h-4
                      inline-block
                      rounded-full
                    "
                    >1</span
                  >
                </button>
                <button
                  @click="cate = 'projects'"
                  :class="[cate == 'projects' ? 'active_blogs_cate' : '']"
                  class="mx-4"
                >
                  Projects
                  <span
                    class="
                      text-xs
                      bg-green-600
                      text-white
                      w-5
                      h-4
                      inline-block
                      rounded-full
                    "
                    >5</span
                  >
                </button>
              </div>
              <button @click="right" class="text-xl flex">
                <i class="fas fa-arrow-right"></i>
              </button>
            </div>
          </div>
          <!-- cate header -->
          <h1 class="mt-2 font-bold" style="text-transform: capitalize">
            {{ cate }}
          </h1>
        </div>

        <div class="flex justify-center">
          <div
            class="
              w-4/5
              grid
              md:grid-cols-3
              gap-x-5 gap-y-5
              place-items-center
              text-slate-50
            "
          >
            <div
              v-if="cate == 'projects' || cate == 'all'"
              :class="[$root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg']"
              class="
                p-5
                w-60
                md:w-48
                lg:w-64
                xl:w-80
                md:h-72
                xl:h-80
                rounded-lg
              "
            >
              <div>
                <img
                  src="images/wannatravel.PNG"
                  class="w-100 object-cover rounded-lg"
                  alt=""
                />
              </div>
              <div class="space-y-14">
                <p
                  :class="[
                    $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                  ]"
                  class="text-md xl:text-lg"
                >
                  Travelling website with Bootstrap. DO YOU WANNA TRAVEL ?
                </p>
                <span class="text-xs bg-green-400 p-1 rounded-lg my-3"
                  >project</span
                >
                <div
                  @click="go('https://wannatravel.netlify.app/')"
                  class="
                    flex
                    items-center
                    cursor-pointer
                    seeMore
                    space-x-2
                    float-right
                  "
                >
                  <a
                    href=""
                    target="_blank"
                    class="text-sm text-sky-600"
                    >Go</a
                  >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-sky-600 transition-all see_more_cta"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div
              v-if="cate == 'projects' || cate == 'all'"
              :class="[$root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg']"
              class="
                p-5
                w-60
                md:w-48
                lg:w-64
                xl:w-80
                md:h-72
                xl:h-80
                rounded-lg
              "
            >
              <div>
                <img
                  src="images/portfolio_project.PNG"
                  class="w-100 object-cover rounded-lg"
                  alt=""
                />
              </div>
              <div class="space-y-14">
                <p
                  :class="[
                    $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                  ]"
                  class="text-md xl:text-lg"
                >
                  My Portfolio landing site with pure css.
                </p>
                <span class="text-xs bg-green-400 p-1 rounded-lg my-3"
                  >project</span
                >
                <div
                  @click="go('https://mryell.netlify.app/')"
                  class="
                    flex
                    items-center
                    cursor-pointer
                    seeMore
                    space-x-2
                    float-right
                  "
                >
                  <a
                    href=""
                    target="_blank"
                    class="text-sm text-sky-600"
                    >Go</a
                  >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-sky-600 transition-all see_more_cta"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div
              v-if="cate == 'projects' || cate == 'all'"
              :class="[$root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg']"
              class="
                p-5
                w-60
                md:w-48
                lg:w-64
                xl:w-80
                md:h-72
                xl:h-80
                rounded-lg
              "
            >
              <div>
                <img
                  src="images/rememberme.PNG"
                  class="w-100 object-cover rounded-lg"
                  alt=""
                />
              </div>
              <div class="space-y-14">
                <p
                  :class="[
                    $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                  ]"
                  class="text-md xl:text-lg"
                >
                  A task that doesn't stink simple web design.
                </p>
                <span class="text-xs bg-green-400 p-1 rounded-lg my-3"
                  >project</span
                >
                <div
                  @click="go('https://remembermeforyourtask.netlify.app/')"
                  class="
                    flex
                    items-center
                    cursor-pointer
                    seeMore
                    space-x-2
                    float-right
                  "
                >
                  <a
                    href="https://remembermeforyourtask.netlify.app/"
                    target="_blank"
                    class="text-sm text-sky-600"
                    >Go</a
                  >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-4 w-4 text-sky-600 transition-all see_more_cta"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M14 5l7 7m0 0l-7 7m7-7H3"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div
                v-if="cate == 'laravel'"
                :class="[$root.isDarkMood ? 'menu_bar_bg' : 'dark_menu_bar_bg']"
                class="
                  p-2
                  md:p-3
                  w-11/12
                  h-64
                  md:w-48
                  lg:w-64
                  xl:w-80
                  md:h-72
                  xl:h-80
                  rounded-lg
                "
              >
                <div>
                  <img
                    src="images/hekokuLaravel.jpeg"
                    class="w-100 object-cover rounded-lg"
                    alt=""
                  />
                </div>
                <div class="space-y-14">
                  <p
                    :class="[
                      $root.isDarkMood ? 'text-slate-50' : 'text-gray-700',
                    ]"
                    class="text-sm xl:text-lg"
                  >
                    How to host laravel project on Heroku for free?
                  </p>
                  <span class="text-xs bg-red-600 p-1 rounded-lg my-3"
                    >laravel</span
                  >
                  <div
                    class="
                      flex
                      items-center
                      cursor-pointer
                      seeMore
                      space-x-2
                      float-right
                    "
                  >
                    <router-link to="/laravel/read" class="text-sm text-sky-600"
                      >Read More</router-link
                    >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-4 w-4 text-sky-600 transition-all see_more_cta"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M14 5l7 7m0 0l-7 7m7-7H3"
                      />
                    </svg>
                  </div>
                </div>
              </div>
          </div>
        </div>
        <div class="flex justify-center">
          <router-link to="all_blogs" class="exp underline mt-10"
            >see all 3 more posts</router-link
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      cate: "all",
    };
  },
  methods: {
    go(url) {
      window.open(url, "_blank");
    },
    right() {
      const conent = document.querySelector("#content");
      conent.scrollLeft += 200;
    },
    left() {
      const conent = document.querySelector("#content");
      conent.scrollLeft -= 200;
    },
  },
};
</script>

<style>
.scroller_cate::-webkit-scrollbar {
  display: none;
}
/* Real Simple card game(prefer to check with medium size screens). */
</style>